import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { MaterialBrandService } from '../material-brand.service';
import MaterialBrandAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-brand/material-brand.entity';
import { LOCALIZED_PROPERTIES, MATERIAL_BRAND_EXPORT_ID, MATERIAL_BRAND_TITLE } from './material-brand.constants';

@Injectable()
export class MaterialBrandExport {
  constructor(
    private exportService: ExportService,
    private materialBrandService: MaterialBrandService,
  ) {}

  private transformItem(item: MaterialBrandAttributes) {
    return {
      code: get(item, 'code', '??'),
      name: get(item, 'name', '??'),
      company: get(item, 'company.name', '??'),
      statusId: this.getStatus(get(item, 'statusId', '')),
    };
  }

  private getStatus(value: string | number): string {
    if(!value && value !== 0) {
        return '';
    }
    return value === 1 ? 'Activo' : 'Inactivo';
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: MATERIAL_BRAND_EXPORT_ID,
      title: MATERIAL_BRAND_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(MATERIAL_BRAND_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.materialBrandService.findByFilter(buildQuery(
          seed(this.materialBrandService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(MATERIAL_BRAND_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(MATERIAL_BRAND_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
